import { ReportData } from './generatePdf';

export const generateJsonReport = (data: ReportData): Blob => {
    const jsonContent = JSON.stringify(data, null, 2);
    return new Blob([jsonContent], { type: 'application/json' });
};
